<template>
  <div class="popup_in">
    <div class="popup pop-results" v-click-outside="onOutside">
      <div class="popup_close close-animate">
        <a href="javascript:void(0);" @click="onOutside"><close-svg /></a>
      </div>
      <SearchFilter v-show="!isMenu" @close="onOutside" @search="onSearch" />

      <div v-show="idToShow" :style="isMenu ? '' : 'margin-top: 30px;'">
        <div v-if="!resultsToShow || !resultsToShow.length">
          <img
            style="width:50px;margin-bottom:22px"
            src="/assets/img/svg/blocked.svg"
          />
          <h2 class="center title">
            לא אותרו מטופלים לרופא
          </h2>
        </div>

        <div v-else>
          <h2 class="title">
            נמצאו {{ resultsToShow.length }} תורים עבור {{ idToShow }}
          </h2>
          <div class="results_box_all has--scroll">
            <div
              class="results_box_row block desk-flex cursor-p"
              @click="onApp(row.appointment_id, row.appType)"
              v-for="(row, index) in resultsToShow"
              :key="index"
            >
              <span class="results_date block">
                {{ row.date }} - {{ row.time }}
              </span>
              <span class="results_tx block">
                <b>{{ row.appType }}</b
                >{{ row.status == "בוטל" ? ", בוטל" : "" }} | {{ row.name }} |
                {{ row.id }} | {{ row.phone }} |
                {{ row.insurance }}
                <span v-if="row.note" class="note block">{{ row.note }}</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CloseSvg from "@/assets/img/svg/close.svg";
import ClickOutside from "vue-click-outside";
import SearchFilter from "@/components/Shared/SearchFilter.vue";
import { getHash } from "../../utilities/hash.js";

export default {
  name: "SearchDesktop",
  props: ["id", "results", "isMenu"],
  components: { CloseSvg, SearchFilter },
  data() {
    return {
      idToShow: "",
      resultsToShow: []
    };
  },
  methods: {
    async onApp(id, type) {
      if (type == "ניתוח") this.$router.push("/surg-info/" + id);
      else this.$router.push("/app-info/" + id);
      this.$emit("close");
    },
    onSearch({ id, results }) {
      this.idToShow = id;
      this.resultsToShow = results;
    },
    onOutside() {
      window.location.hash = getHash({ searchQuery: "", searchType: "" });
      this.$emit("close");
    }
  },
  mounted() {
    this.idToShow = this.id;
    this.resultsToShow = this.results;
  },
  directives: {
    ClickOutside
  }
};
</script>
